import { create } from "zustand";

interface BalanceSyncState {
  isSyncing: boolean;
  syncStartedAt: number | null;
  currentHash: string | null;
  previousHash: string | null;
  startSync: () => void;
  recordHash: (hash: string) => void;
  endSync: () => void;
  hashesMatch: () => boolean;
}

export const useBalanceSyncStore = create<BalanceSyncState>((set, get) => ({
  isSyncing: false,
  syncStartedAt: null,
  currentHash: null,
  previousHash: null,

  startSync: () =>
    set({
      isSyncing: true,
      syncStartedAt: Date.now(),
      currentHash: null,
      previousHash: null,
    }),

  recordHash: (hash: string) =>
    set((state) => ({
      previousHash: state.currentHash,
      currentHash: hash,
    })),

  endSync: () =>
    set({
      isSyncing: false,
      syncStartedAt: null,
      currentHash: null,
      previousHash: null,
    }),

  hashesMatch: () => {
    const { currentHash, previousHash } = get();
    return currentHash !== null && previousHash !== null && currentHash === previousHash;
  },
}));
